const isDefined = value => typeof value === 'number' || (value?.length || 0) > 0;
const validateWebForwards = (__, webForwards) => {
  const errors = webForwards.map(webForward => {
    if (!isDefined(webForward.targetUrl)) {
      return {
        targetUrl: __('Required')
      };
    }
    return undefined;
  });
  if (errors.filter(Boolean).length > 0) {
    return errors;
  }
  return undefined;
};
const validateNsAndRecords = (__, nsAndRecords) => {
  const errors = {};
  if (nsAndRecords.nameserversType === 'livedns' && !isDefined(nsAndRecords.recordsType)) {
    errors.recordsType = __('Required');
  }
  if (nsAndRecords.recordsType === 'custom' && !isDefined(nsAndRecords.records)) {
    errors.records = __('Required');
  }
  if (nsAndRecords.nameserversType === 'custom' && !isDefined(nsAndRecords.nameservers)) {
    errors.nameservers = __('Required');
  }
  return Object.keys(errors).length ? errors : undefined;
};
export function createValidate(__, options) {
  return values => {
    const errors = {};
    if (!isDefined(values.name)) {
      errors.name = __('Required');
    }
    if (!isDefined(values.sharingId) && !options?.ignoreSharingId) {
      errors.sharingId = __('Required');
    }
    if (values.mailboxes && !isDefined(values.mailboxes.mailbox1) &&
    // $FlowFixMe[incompatible-use]
    !isDefined(values.mailboxes.mailbox2)) {
      errors.mailboxes = {
        mailbox1: __('Required')
      };
    }
    if (values.webForwards) {
      errors.webForwards = validateWebForwards(__, values.webForwards);
    }
    if (values.nsAndRecords) {
      errors.nsAndRecords = validateNsAndRecords(__, values.nsAndRecords);
    }
    return errors;
  };
}